import { render, staticRenderFns } from "./ViewArticleSection.vue?vue&type=template&id=4c9695b8&scoped=true"
import script from "./ViewArticleSection.vue?vue&type=script&lang=js"
export * from "./ViewArticleSection.vue?vue&type=script&lang=js"
import style0 from "./ViewArticleSection.vue?vue&type=style&index=0&id=4c9695b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9695b8",
  null
  
)

export default component.exports